import Vue from 'vue';
import { each, get, isString } from 'lodash';
import authErrorHandler from '@/service/handler/auth-error';

const API_URL = process.env.VUE_APP_API_URL;

import { Product } from './types';
import { IProductStateDict } from '@/store/types';

const convertResponseProduct = (raw: any): Product => {
  return new Product(raw);
}

const convertResponseProducts = (raw: any): IProductStateDict => {
  let dict: IProductStateDict = {};
  each(raw, (item: any) => {
    let p = convertResponseProduct(item);
    dict[p.id] = p;
  });
  return dict;
}

const productService = {
  async getAll(): Promise<IProductStateDict|void> {
    return Vue.$axios
      .post(`${API_URL}/products`, {
        "where": {},
        "orderBy": {
          "id": "ASC"
        }
      })
      .then((resp) => {
        return convertResponseProducts(get(resp, 'data.data.products', []));
      })
      .catch(reason => {
        if (isString(reason)) {
          authErrorHandler();
        }
      });
  },
  async getOne(id: number): Promise<Product> {
    return Vue.$axios
      .get(`${API_URL}/product/${id}`)
      .then((resp) => {
        return convertResponseProduct(get(resp, 'data.data.Product', {}));
      })
      .catch(reason => {
        if (isString(reason)) {
          authErrorHandler();
        }
        return reason;
      });
  },
  async getCustom(params: any): Promise<IProductStateDict|void> {
    const paramsMerged = Object.assign({
      "where": {},
      "orderBy": {
        "id": "ASC"
      }
    }, params)
    return Vue.$axios
      .post(`${API_URL}/products`, paramsMerged)
      .then((resp) => {
        return convertResponseProducts(get(resp, 'data.data.products', []));
      })
      .catch(reason => {
        if (isString(reason)) {
          authErrorHandler();
        }
      });
  },
};

// @ts-ignore
window.productService = productService;

export default productService;
